require("./SectionFooter.less");

const React = require("react");
const T = React.PropTypes;
const SectionType = require("~/types/Section.js").PropType;

const SectionFooter = React.createClass({
    propTypes: {
        IsFirstSection: T.bool.isRequired,
        IsLastSection: T.bool.isRequired,
        OnPrevious: T.func.isRequired,
        OnNext: T.func.isRequired,
        OnComplete: T.func.isRequired,
        OnSave: T.func.isRequired,
        CanSave: T.bool,
        Message: T.node
    },
    render() {
        const hasMessage = this.props.Message !== null;

        return (<footer className="cs-SectionFooter">
            <div className="cs-SectionFooter__left">
                {!this.props.IsFirstSection && (
                    <button onClick={this.props.OnPrevious} className="cs-SectionFooter__PreviousButton btn btn-primary">
                        <span className="cs-SectionFooter__PreviousButton__icon glyphicon glyphicon-arrow-left" aria-hidden="true"></span>
                        Previous Section
                    </button>)}
            </div>
            <div className="cs-SectionFooter__mid">
                {this.props.CanSave && (<button className="btn btn-success cs-SectionFooter__SaveButton"
                        onClick={this.props.OnSave}>
                    <span className="glyphicon glyphicon-floppy-disk cs-SectionFooter__SaveButton__Icon"></span>
                    Save
                </button>)}
                {hasMessage && (<span className="cs-SectionFooter__Message">
                    {this.props.Message}
                </span>)}
            </div>
            <div className="cs-SectionFooter__right">
                <div>
                    {!this.props.IsLastSection && (
                        <button onClick={this.props.OnNext} className="cs-SectionFooter__NextButton btn btn-primary">
                            Next Section
                            <span className="cs-SectionFooter__NextButton__icon glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
                        </button>)}
                </div>
                <div>
                    {this.props.IsLastSection && (
                    <button className="cs-SectionFooter__SubmitButton btn btn-primary"
                            onClick={this.props.OnComplete}>
                        Review and submit
                    </button>)}
                </div>
            </div>
        </footer>);
    }
});

module.exports = SectionFooter;



// WEBPACK FOOTER //
// ./src/components/SectionFooter/SectionFooter.jsx